<template>
  <div class="home-page" style="padding: 0;">
    <Header></Header>
    <div class="home-content crfff">
      <div class="header-bgfff">
        <div class="nav ac">
          <div class="back" @click="back" >
            <img width="80" src="../../static/images/back2.png" />
          </div>
          <div class=" disflex por ac" style="padding-top: 30px;justify-content: center;">
            <div class="nav-t"><span>{{book_detail.name}}</span></div>
            <div class="download" @click="download" >
              <img width="70"  src="../../static/images/download.png" />
            </div>
          </div>
        </div>
      </div>
      <div class="home-content">
        <div class="pdf-viewer" v-if="book_detail.path">
          <div class="viewer-controls">
            <div class="page-navigation">
              <button class="nav-btn" @click="prevPage" :disabled="currentPage <= 1">
                ←
              </button>
              <span class="page-indicator">{{ currentPage }} / {{ totalPages }}</span>
              <button class="nav-btn" @click="nextPage" :disabled="currentPage >= totalPages">
                →
              </button>
            </div>

          </div>

          <div class="pdf-container">
            <div v-if="loading" class="loading">
              <p>{{$t('load_book')}}</p>
            </div>
            <div v-else-if="error" class="error-message">
              <p>{{$t('load_book_failed')}}</p>
              <button class="reload_button" @click="loadPdf">{{$t('reload')}}</button>
            </div>
            <canvas v-else id="pdf-canvas"></canvas>
          </div>
        </div>
      </div>
    </div>


    <Dialog ref="downloadDialog" type="alert" title="Reminder" width="80" :modalFoot="false">
      <div class="invited-c ac" slot="mdBox" style="">
        <div class="invited-l">
          <h2 class="ac mt30 font-family "  style="color: #865a30;font-size: 50px">{{ book_detail.name }}</h2>
          <div class="level-img-wrapper" style="margin-top: 30px;" >
            <img :src="book_detail.image" class="level-img" style="width: 60%;display: block;margin: 0 auto">
          </div>
          <div style="margin-top: 30px;">
            <span style="color: #865a30;font-size: 30px">{{$t('downTips1')}}</span>
          </div>
        </div>
        <div class="modal-footer ac" >
          <div class="sig" >
            <button id="copycode" :data-clipboard-text="book_detail.path" style="font-size: 30px" class="btn btn-blue" @click="copy_book_path">{{$t('copyLink')}}</button>
          </div>
        </div>
      </div>
    </Dialog>
  </div>
</template>

<script>
import Header from '../components/HeaderOne'
import Dialog from '../components/dialog'

export default {
  components: {
    Header,
    Dialog
  },
  data() {
    return {
      book_detail: {},
      id: 1,
      pdfDoc: null,
      currentPage: 1,
      totalPages: 0,
      zoom: 1.2,
      loading: false,
      error: false,
      isBookmarked: false,
      _notificationTimer: null
    }
  },
  created() {
    if (this.$route.query.id) {
      this.id = this.$route.query.id
      this.get_detail();
    }
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    download(){
      let that =this;
      that.$refs.downloadDialog.showMaskFun();
    },
    copy_book_path(){
      const text = this.book_detail.path;
      if (!text) return;
      navigator.clipboard.writeText(text).then(() => {
        this.$utils.alertText(this.$t('CopySucceeded'));
        this.$refs.downloadDialog.closeMask();
      }).catch(err => {
        console.error('复制失败:', err);
        this.$utils.alertText(this.$t('CopyFailed'));
      });
    },

    get_detail() {
      let that = this;
      that.$parent.loadModal(true);
      that.$api.post('/api/book/detail', {"id": that.id}, r => {
        that.$parent.returnCode(r, function () {
          that.$parent.loadModal(false);
          that.book_detail = r.data;
          if (that.book_detail.path) {
            that.loadPdf();
          }
        });
      })
    },

    loadPdf() {
      this.loading = true;
      this.error = false;

      const pdfjsLib = window['pdfjs-dist/build/pdf'];
      pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.4.120/pdf.worker.min.js';

      // let path = "../../static/pdf/book_1.pdf";
      // const loadingTask = pdfjsLib.getDocument(path);
      const loadingTask = pdfjsLib.getDocument(this.book_detail.path);

      loadingTask.promise.then((pdf) => {
        this.pdfDoc = pdf;
        this.totalPages = pdf.numPages;
        this.loading = false;
        this.renderPage(this.currentPage);
      }).catch((err) => {
        console.error('PDF加载失败:', err);
        this.loading = false;
        this.error = true;
      });
    },

    renderPage(num) {
      if (!this.pdfDoc) return;
      this.pdfDoc.getPage(num).then(page => {
        const viewport = page.getViewport({scale: this.zoom});
        const canvas = document.getElementById('pdf-canvas');
        const ctx = canvas.getContext('2d');
        // 1. 设置canvas内部像素尺寸（高清渲染）
        const outputScale = window.devicePixelRatio || 1;
        canvas.width = viewport.width * outputScale;
        canvas.height = viewport.height * outputScale;

        // 2. 设置canvas在页面上的显示尺寸（自适应宽100%）
        canvas.style.width = '100%';
        canvas.style.height = 'auto';

        ctx.setTransform(outputScale, 0, 0, outputScale, 0, 0); // 高清屏适配
        ctx.clearRect(0, 0, canvas.width, canvas.height);

        page.render({canvasContext: ctx, viewport});
      });
    },

    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.renderPage(this.currentPage);
      }
    },

    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.renderPage(this.currentPage);
      }
    },

    zoomIn() {
      if (this.zoom < 3) {
        this.zoom += 0.1;
        this.renderPage(this.currentPage);
      }
    },

    zoomOut() {
      if (this.zoom > 0.5) {
        this.zoom -= 0.1;
        this.renderPage(this.currentPage);
      }
    },

    toggleBookmark() {
      this.isBookmarked = !this.isBookmarked;
      clearTimeout(this._notificationTimer);
      this._notificationTimer = setTimeout(() => {
      }, 3000);
    }
  }
}
</script>

<style scoped>
.pdf-viewer {
  width: 100%;
  height: calc(100vh - 150px);
  /* background: white; */
  border-radius: 12px;
  /* box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1); */
  overflow: hidden;
  display: flex;
  flex-direction: column;
  padding:20px;
}

.viewer-controls {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 20px;
  border-radius: 20px;
}

.page-navigation {
  display: flex;
  align-items: center;
  gap: 15px;
}

.nav-btn {
  font-size: 30px;
  font-weight: 500;
  width: 80px;
  height:80px;
  border-radius: 50%;
  background:linear-gradient(to bottom, #dc5434, #e47e1f);
  color: white;
  border: 4px solid #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
}

.nav-btn:hover {
  background:linear-gradient(to bottom, #dc5434, #e47e1f);
  transform: scale(1.05);
}

.nav-btn:disabled {
  background: #ccc;
  cursor: not-allowed;
  transform: none;
}

.page-indicator {
  font-size: 25px;
  font-weight: 500;
  color: #1a3c5a;
}

.viewer-options {
  display: flex;
  align-items: center;
  gap: 15px;
}

.zoom-controls {
  display: flex;
  align-items: center;
  gap: 10px;
  background: white;
  padding: 8px 15px;
  border-radius: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.zoom-btn {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #f8f9fa;
  color: #495057;
  border: 1px solid #e9ecef;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
}

.zoom-btn:hover {
  background: #e9ecef;
}

.bookmark-btn {
  padding: 8px 16px;
  background: #ff6b6b;
  color: white;
  border: none;
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
}

.bookmark-btn:hover {
  background: #ff5252;
  transform: translateY(-2px);
}

.bookmark-btn.bookmarked {
  background: #4cd964;
}

.pdf-container {
  flex: 1;
  width: 100%;      /* 宽度撑满 */
  overflow-x: hidden; /* 不允许水平滚动 */
  overflow-y: auto;  /* 允许垂直滚动 */
  display: flex;
  justify-content: center;
  align-items: flex-start;
  //padding-top: 30px;
}

canvas {
  max-width: 100%;
  height: auto;
  border-radius: 20px;
}

.pdf-page {
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
}

.loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  gap: 20px;
  color: #6c757d;
}

.spinner {
  width: 50px;
  height: 50px;
  border: 5px solid rgba(74, 124, 255, 0.2);
  border-radius: 50%;
  border-top-color: #4a7cff;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.error-message {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 80%;
  gap: 20px;
  color: #dc3545;
  text-align: center;
  padding: 20px;
}

@media (max-width: 768px) {
  .viewer-controls {
    flex-direction: column;
    gap: 15px;
  }

  .viewer-options {
    width: 100%;
    justify-content: space-between;
  }
}

.reload_button{
  background-color: orange;
  width: 400px;
  height: 100px;
  font-size: 30px;
  border-radius: 40px;
  font-weight: 300;
}

</style>



// WEBPACK FOOTER //
// src/page/BookDetail.vue